// extracted by mini-css-extract-plugin
export default {"agentLimit":"Limits_agentLimit__nBCA+"};